const state = () => ({
  group: null,
})

const getters = {
  group: (state) => state.group,
}

const mutations = {
  receiveGroup(state, group) {
    state.group = group
  },
}

const actions = {
  getGroup({ commit, rootState }, groupId) {
    return this.$axios
      .post('/fitness-app-backend/v1/core/groups/get', {
        accessToken: rootState.user.token,
        id: +groupId,
      })
      .then((response) => {
        commit('receiveGroup', response.data.group)
      })
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
}
